import { Divider } from '@material-ui/core'
import { addSeconds, format, getSeconds, parse, subDays } from 'date-fns'
import enLocale from 'date-fns/locale/en'
import React, { useState } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import Flex from 'typescript-styled-flex'
import { dateFormat } from '../../../../utils/DateFormat'
import { IWithSize } from '../../../../containers/BookingCalendar/Calendar/Calendar'
import { calculateDays } from '../../../../utils/License/getDays'
import DateLabel from './DateLabel'
import LicenseWrapper from './LicenseWrapper'
import TimeWrapper from './TimeWrapper'
import { isEmpty } from 'lodash'
import styled from '../../../../theme'
import { dateWithoutOffsert } from '../../../../models/License/mappers/mapResponseToLicense'
import Button from '../../Button'
import { getPanelUrlForEnv } from '../../../../utils/ApiUrl'
import { useSelector } from 'react-redux'
import { getAccessToken } from '../../../../reducers/userAccount/selectors/credentials'
import Error from '../../../../assets/icons/error2.svg'
import { is } from '../../../MediaQuery'
import PremiumModal from '../../../../screens/Premium/PremiumModal'
import { isUserNewPackage } from '../../../../reducers/userAccount/selectors/userAccount'
import { isNewPremiumLicenseValid } from '../../../../reducers/userAccount/selectors/license'

const SubTitle = styled.div`
  color: #a1a1a1;

  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 166.667% */
  letter-spacing: 0.036px;
`

function License({
  icon,
  label,
  endTime,
  rawEnd,
  startTime,
  roomLimit,
  t,
  style,
  awaits = false,
  size = 1,
  formatDate,
  more = false,
  sub,
}: ILicense & WithTranslation & IWithSize) {
  const [open, setOpen] = useState(false)
  const key = useSelector(getAccessToken)
  const startTimeAdded =
    getSeconds(startTime) === 59 ? addSeconds(startTime, 1) : startTime
  const newPacakgePremium = useSelector(isNewPremiumLicenseValid)
  const isNewPremiumPriceGroup = useSelector(isUserNewPackage)
  const isNewPremiumSubUser =
    newPacakgePremium && isNewPremiumPriceGroup && !!sub

  function getDays() {
    const diff = awaits
      ? calculateDays(rawEnd, startTimeAdded as Date)
      : calculateDays(
          getSeconds(startTime) === 59 ? addSeconds(rawEnd, 1) : rawEnd,
        )

    return (
      <DateLabel size={size} red={diff <= 7}>
        {diff} {t(diff === 1 ? 'days_count_day' : 'days')}
      </DateLabel>
    )
  }

  const close = () => {
    setOpen(false)
  }

  function getDate(time) {
    return format(
      parse(time),
      dateFormat(formatDate ? formatDate : 'dd/MM/yyyy'),
      { locale: enLocale },
    )
  }

  const isSub = !isEmpty(sub)
  const subError = sub && sub.status_extended === 'PAYMENT_ERROR'

  const onClick = () => {
    window.location.href = `${getPanelUrlForEnv()}/index/login?autologinkey=${key}&redirect=/payment`
  }

  const deleteSub = () => {
    setOpen(true)
  }

  const isDesktop = is.desktop()

  return (
    <React.Fragment>
      {isSub && (
        <PremiumModal
          end={getDate(endTime)}
          license={sub}
          open={open}
          close={close}
          id={sub.id_order}
        />
      )}
      <Divider />
      <LicenseWrapper
        column={true}
        more={more && isDesktop}
        size={size}
        style={
          more && !isDesktop
            ? { ...style, paddingRight: '25px',  }
            : {
                ...style,
                minWidth: isNewPremiumSubUser ? '366px' : '269px',
              }
        }
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            marginTop: '8px',
          }}
        >
          {icon}
          <LicenseText style={{ fontSize: '14px' }}>
            {label}{' '}
            {!isNewPremiumSubUser && roomLimit && roomLimit.name !== ''
              ? `(${roomLimit.name} ${t('BKO_1130_rooms')})`
              : ''}
          </LicenseText>
        </div>
        {isNewPremiumSubUser && (
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <p style={{ fontSize: '12px', color: '#000', fontWeight: 500 }}>
              {t('BBO_157_rooms')}
            </p>
            <p style={{ fontSize: '12px', color: '#000', fontWeight: 500 }}>
              {roomLimit.name}
            </p>
          </div>
        )}
        {isSub && isDesktop && (
          <SubTitle
            style={{
              paddingLeft: isNewPremiumSubUser
                ? 'unset'
                : more
                ? '53px'
                : '42px',
            }}
          >
            {t('BED_26041_auto_renewal_subscription')} (
            {t(
              Number(sub.last_license.period) === 7
                ? 'BED_26041_duration_7_months'
                : sub.last_license.period > 11
                ? `BED_26041_duration_${sub.last_license.period}_months`
                : `BED_22412_duration_${sub.last_license.period}_month${
                    sub.last_license.period > 1 ? 's' : ''
                  }`,
            )}
            )
          </SubTitle>
        )}
      </LicenseWrapper>
      {isSub && !isDesktop && (
        <SubTitle
          style={{
            padding: '0px 18px',
            paddingBottom: '18px',
          }}
        >
          {t('BED_26041_auto_renewal_subscription')} (
          {t(
            Number(sub.last_license.period) === 7
              ? 'BED_26041_duration_7_months'
              : sub.last_license.period > 11
              ? `BED_26041_duration_${sub.last_license.period}_months`
              : `BED_22412_duration_${sub.last_license.period}_month${
                  sub.last_license.period > 1 ? 's' : ''
                }`,
          )}
          )
        </SubTitle>
      )}
      <Flex column={true}>
        <TimeWrapper subError={subError} size={size} style={style}>
          <Flex justifyBetween={true} style={{ marginBottom: '5px' }}>
            <LicenseText>
              {t('reservation_from')} {getDate(startTime)}
            </LicenseText>
            <LicenseText>
              {t('reservation_to')} {getDate(endTime)}
            </LicenseText>
          </Flex>
          {isSub ? (
            <>
              <Flex
                justifyBetween={true}
                style={more ? { paddingBottom: '5px' } : {}}
              >
                <LicenseText>{t('BED_16495_next_payment')}</LicenseText>
                <LicenseText>
                  {getDate(
                    subDays(
                      dateWithoutOffsert(
                        new Date(
                          Number(sub.last_license.service_period_end) * 1000,
                        ),
                        true,
                      ),
                      3,
                    ),
                  )}
                </LicenseText>
              </Flex>
              {more && (
                <>
                  <Flex
                    justifyBetween={true}
                    style={more ? { paddingBottom: '5px' } : {}}
                  >
                    <LicenseText>{t('BBO_3071_amount')}</LicenseText>
                    <LicenseText>
                      {sub.last_license.amount_in_cents / 100}{' '}
                      {sub.last_license.currency}
                    </LicenseText>
                  </Flex>
                  {!subError && (
                    <Flex
                      justifyBetween={true}
                      style={more ? { paddingBottom: '5px' } : {}}
                    >
                      <div></div>
                      <Link onClick={deleteSub}>
                        {t('BED_26049_cancel_subscription')}
                      </Link>
                    </Flex>
                  )}
                </>
              )}
            </>
          ) : (
            <Flex style={{ marginTop: '5px' }}>
              <LicenseText style={{ display: 'flex', alignItems: 'center' }}>
                {t('days_count_remaining')}&nbsp;{getDays()}
              </LicenseText>
            </Flex>
          )}
          {isSub && subError && (
            <ErrorWrapper>
              <ErrorIconWrapper size={size}>
                <img
                  style={{
                    marginRight: '5px',
                  }}
                  alt={'icon'}
                  src={Error}
                />
                <ErrorTextWrapper>
                  {t('BED_26058_unable_collect_payment_text')}{' '}
                  <span style={{ fontWeight: 700 }}>
                    {getDate(
                      dateWithoutOffsert(
                        new Date(
                          Number(sub.last_license.service_period_end) * 1000,
                        ),
                        true,
                      ),
                    )}
                  </span>
                </ErrorTextWrapper>
              </ErrorIconWrapper>
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  style={{
                    padding: '6px 30px',
                  }}
                  primary={true}
                  onClick={onClick}
                >
                  {t('BED_26058_fix_payment_button')}
                </Button>
              </div>
            </ErrorWrapper>
          )}
        </TimeWrapper>
      </Flex>
    </React.Fragment>
  )
}

const Link = styled.div`
  color: #d83a3a;

  text-align: right;
  font-family: Montserrat, sans-serif;
  cursor: pointer;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 233.333% */
`

const ErrorWrapper = styled.div``

const LicenseText = styled.div`
  color: #000;

  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

const ErrorIconWrapper = styled.div<{ size: any; more?: boolean }>`
  display: flex;
  padding: 10px 0px;
  align-items: flex-start;
  width: ${({ size }) => (size ? 287 * size : 287)}px;
  @media (max-width: ${props => props.theme.breakpoints.mobile}) {
    width: ${({ size }) => (size ? 275 * size : 275)}px;
  }
`

export const ErrorTextWrapper = styled.div`
  color: #d83a3a;

  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 133.333% */
  letter-spacing: 0.036px;
`

export default withTranslation()(License)

export interface ILicense {
  icon: JSX.Element
  label: string
  endTime: Date | string
  startTime?: Date | string
  awaits?: boolean
  roomLimit?: any
  rawEnd: Date
  style?: React.CSSProperties
  formatDate?: string
  sub?: any
  more?: boolean
}
